import React, { useState } from "react";
import styled, { createGlobalStyle } from "styled-components";
import { GlobalStyleProps } from '../types/types'
import Sidebar from "../common/components/Sidebar";
import Header from "../common/components/Header";
import Footer from "../common/components/Footer";

import { spacing } from "@material-ui/system";
import {
    Hidden,
    CssBaseline,
    Paper as MuiPaper,
    withWidth
} from "@material-ui/core";


import { isWidthUp } from "@material-ui/core/withWidth";

import EditModifiersSetForm from "../modules/menu/pages/modifiersSet/components/EditModifiersSetForm";
import { SnackbarComponent } from "../common/components/Snackbars";
import TranslationEditor from "../common/components/translation/TranslationEditor";
const drawerWidth = 260;

const GlobalStyle = createGlobalStyle<GlobalStyleProps>`
  html,
  body,
  #root {
    height: 100%;
  }

  body {
    background: ${props => props.theme.body.background};
  }

  .MuiCardHeader-action .MuiIconButton-root {
    padding: 4px;
    width: 28px;
    height: 28px;
  }
`;

const Root = styled.div`
  display: flex;
  min-height: 100vh;
`;

const Drawer = styled.div`
  ${props => props.theme.breakpoints.up("lg")} {
    width: ${drawerWidth}px;
    flex-shrink: 0;
  }
`;

const AppContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

const Paper = styled(MuiPaper)(spacing);

const MainContent = styled(Paper)`
  flex: 1;
  background: ${props => props.theme.body.background};

  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    flex: none;
  }

  .MuiPaper-root .MuiPaper-root {
    box-shadow: none;
  }
`;

type DashboardPropsType = {
    route: any
    width: "md" | "xs" | "sm" | "lg" | "xl",
}

const LayoutWithMenu: React.FC<DashboardPropsType> = ({ route, width,children }) => {
    const [mobileOpen, setMobileOpen] = useState(false);

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    return (
        <Root>
            <CssBaseline/>
            <GlobalStyle/>
            <Drawer>
                <Hidden lgUp implementation="js">
                    <Sidebar
                        routes={route.routes}
                        PaperProps={{ style: { width: drawerWidth } }}
                        variant="temporary"
                        open={mobileOpen}
                        onClose={handleDrawerToggle}
                    />
                </Hidden>
                <Hidden mdDown implementation="css">
                    <Sidebar
                        routes={route.routes}
                        PaperProps={{ style: { width: drawerWidth } }}
                    />
                </Hidden>
            </Drawer>
            <AppContent>
                <Header onDrawerToggle={handleDrawerToggle}/>
                <SnackbarComponent/>
                <MainContent p={isWidthUp("md", width) ? 10 : 2} pt={10}>
                    {children}
                </MainContent>
                <Footer/>
            </AppContent>

            <EditModifiersSetForm/>
            <TranslationEditor/>
           {/* <UpdateAliasForm/>*/}
            {/*<Settings />*/}
        </Root>
    )
};

export default withWidth()(LayoutWithMenu);
